module.exports = __webpack_public_path__ + "media/images/man-in-vacation-with-big-yellow-suitcase-feeling-happy-on-blue-52462980e1b756b056f8d2fd9e58dd38.jpg";